module.exports = __webpack_public_path__ + "static/media/grant-management.a719dac9.svg";